<template>
  <section class="container pagination">
    <el-pagination
      :page-size="itemsOnPage"
      :pager-count="docWidth < 450 ? 4 : 7"
      layout="prev, pager, next"
      @current-change="$emit('change', $event)"
      :total="totalItems"
      :current-page="currentPage"
    >
      <!-- :total = кількість всього елементів !-->
      <!--page size = Кількість відображенних елементів на сторінці !-->
    </el-pagination>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Pagination',
  components: {},
  props: {
    itemsOnPage: Number,
    totalItems: Number,
    currentPage: Number,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      docWidth: 'getDocumentWidth',
    }),
  },
}
</script>
